// extracted by mini-css-extract-plugin
export default {"sections":"ProjectSiteModal_sections__672ls","cardList":"ProjectSiteModal_cardList__vaksg"};